'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var forEach = require('../iterable/forEach');
var truncateLast = require('../iterable/truncateLast');
var type = require('../value/type');

var isBadType = function isBadType(value, Type) {
  return value === undefined || value !== null && value.constructor !== Type && !(value instanceof Type);
};

var checkType = function checkType(value, Type) {
  switch (type(Type)) {
    case 'array':
      if (value !== null && type(value) !== 'array') {
        throw new TypeError('Expected "' + value + '" to be of Type "Array"');
      }
      return forEach(value || [], function (item) {
        return checkType(item, Type[0]);
      });
    case 'function':
      if (isBadType(value, Type)) {
        throw new TypeError('Expected "' + value + '" to be of Type "' + Type.name + '"');
      }
      return;
    default:
      throw new TypeError('Expected Type to be a function, got "' + Type + '"');
  }
};

var checkTypes = function checkTypes(Types, args) {
  forEach(Types, function (Type, i) {
    var arg = args[i];
    checkType(arg, Type);
  });
};

var enforceTypes = function enforceTypes(context, Types, fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    while (context.RestType && Types.length < args.length) {
      Types.push(context.RestType);
    }
    checkTypes(Types, args);
    return fn.apply(undefined, args);
  };
};

var theRestAre = function theRestAre(context, exportedFn) {
  return function (RestType) {
    context.RestType = RestType;
    return exportedFn;
  };
};

module.exports = function () {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var context = {};

  var _truncateLast = truncateLast(args),
      _truncateLast2 = _slicedToArray(_truncateLast, 2),
      Types = _truncateLast2[0],
      fn = _truncateLast2[1];

  var exportedFn = enforceTypes(context, Types, fn);
  exportedFn.theRestAre = theRestAre(context, exportedFn);
  return exportedFn;
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/enforceTypes.js
// module id = 2170
// module chunks = 37